import type { CircleLayer } from 'react-map-gl';

const MarkerStrokeLayer: CircleLayer = {
  id: "marker-stroke-layer",
  type: "circle",
  paint: {
    'circle-radius': [
      'interpolate',
      ['linear'],
      ['get', 'count'],
      0,   12, 
      100, 22
    ],
    "circle-opacity": 0,
    "circle-color": "transparent",
    "circle-stroke-color": "white",
    "circle-stroke-opacity": 0.5,
    "circle-stroke-width": 4
  }
}

export { MarkerStrokeLayer }
